export default __webpack_public_path__ + "static/media/share_whatsapp.5976d356.svg";